import script from "./VirtualMuseum.vue?vue&type=script&lang=ts&setup=true"
export * from "./VirtualMuseum.vue?vue&type=script&lang=ts&setup=true"

import "./VirtualMuseum.vue?vue&type=style&index=0&id=053f967e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053f967e"]])

export default __exports__